import { GameInfo, Stage } from "../../../../analytics/GameInfo";
import { INetworkConfig } from "../INetworkConfig";

export class DefaultNetworkConfig implements INetworkConfig {
    public constructor(
        private readonly gameInfo: GameInfo
    ) {
    }

    public get guestsMeProfilePath(): string {
        return "/guests/me/profile";
    }
    public get guestsApiPath(): string {
        return "/guests";
    }
    public get guestsMePath(): string {
        return "/me";
    }
    public get currentGuestActionPath(): string {
        return "/actions/current";
    }
    public get claimActionPath(): string {
        return "/actions/claim-current";
    }
    public get apiURL(): string {
        return this.gameInfo.serverUrl;
    }
    public get apiVersion(): string {
        return "v1";
    }
    public get apiV2Version(): string {
        return "v2";
    }
    public get guestBuildingsPath(): string {
        return "/guest-buildings";
    }
    public get dailyBonusWheelPath(): string {
        return "/daily-bonus-wheel";
    }
    public get claimBonusWheelRewardPath(): string {
        return "/claim-reward";
    }
    public get hourlyBonusPath(): string {
        return "/hourly-bonus";
    }
    public get claimHourlyBonusPath(): string {
        return "/claim";
    }
    public get hourlyBonusBurnPath(): string {
        return "/web3/burn/status";
    }
    public get goldenWheelPath(): string {
        return "/golden-wheel";
    }
    public get piggyWheelPath(): string {
        return "/piggy-wheel";
    }
    public get buildingUpgradesPath(): string {
        return "/building-upgrades";
    }
    public get paymentsPath(): string {
        return "/order";
    }
    public get bluesnapWalletPath(): string {
        return "/bluesnap-wallet";
    }
    public get bluesnapPath(): string {
        return "/bluesnap";
    }
    public get bluesnapCreditCardPath(): string {
        return "/bluesnap-credit-card";
    }
    public get marketplaceBuildingsPath(): string {
        return "/marketplace/buildings";
    }
    public get marketplaceNewsPath(): string {
        return "/marketplace/ticker-news";
    }
    public get merketplaceMapPointsPath(): string {
        return "/marketplace/map-points";
    }
    public get shopPath(): string {
        return "/store/store-offers";
    }
    public get personalOfferPath(): string {
        return "/personal-offers";
    }
    public get personalOfferOutOfRollsPath(): string {
        return "/out-of-dice-rolls"
    }
    public get authPath(): string {
        return "/auth";
    }
    public get refreshTokenPath(): string {
        return "/refresh-token";
    }
    public get firstTimeExperiencePath(): string {
        return "/first-time-experience";
    }
    public get renterPolicyPath(): string {
        return "/renter-policy";
    }
    public get leaderboardPath(): string {
        return "/building-leaderboard";
    }
    public get latestNews(): string {
        return "/latest-news";
    }
    public get piggyBankPath(): string {
        return "/piggy-bank";
    }
    public get benefitsPath(): string {
        return "/benefits";
    }
    public get web3Auth(): string {
        return "/auth-web3-eth";
    }
    public get prepareMintPath(): string {
        return "prepare-mint";
    }
    public get successPurchaseBuildingPath(): string {
        return "/purchase-building/on-success";
    }
    public get successPurchaseStorePackageOnL1Path(): string {
        return "/store/web3/purchase-l1/status";
    }
    public get successPurchaseStorePackageOnBasePath(): string {
        return "/store/web3/purchase-l2/status"; 
    }
    public get successStoreBurnPath(): string {
        return "/store/web3/burn/status";
    }
    public get web3BurnStatusPath(): string {
        return "/web3/burn/status";
    }
    public get giftActionCardsPath(): string {
        return "/gift-action/reveal/cards";
    }
    public get raidActionCardsPath(): string {
        return "/raid-action/reveal/cards";
    }
    public get raidActionTargetsPath(): string {
        return "/raid-action/reveal/targets";
    }
    public get visitActionCardsPath(): string {
        return "/visit-action/reveal/cards";
    }
    public get stealActionCardsPath(): string {
        return "/steal-action/reveal/cards";
    }
    public get piggyClubs(): string {
        return "/piggy-clubs";
    }

    public get tournamentsSettings(): string {
        return "/tournaments/settings";
    }
}
